import { __ } from '@oat-sa-private/ui-core';

__('No entities found in the file');
__('Student performance');
__('Opened on');
__('Closed on');
__('Test taker');
__('Test takers');
__('Groups');
__('Sessions');
__('Group performance');